import React from 'react'
import clsx from 'clsx'

export interface Props {
  data: {
    id: string
    title: string
    lines: {
      id: string
      title: string
      price?: string | null
    }[]
  }[]
  verticalSpacing?: 'sm' | 'md'
}

const PriceList: React.FC<Props> = ({ data, verticalSpacing = 'sm' }) => (
  <div
    className={clsx(
      verticalSpacing === 'sm' && 'space-y-2',
      verticalSpacing === 'md' && 'space-y-6'
    )}
  >
    {data.map((menu) => (
      <div key={menu.id}>
        <p className="font-semibold md:text-lg">{menu.title}</p>
        {menu.lines && (
          <ul className="space-y-1.5 text-sm md:space-y-0.5 md:pl-2 md:text-base">
            {menu.lines.map((item) => (
              <li
                key={item.id}
                className="relative pl-4 leading-snug md:flex md:justify-between md:space-x-5"
              >
                <div className="before:absolute before:-top-px before:left-0 before:content-['•']">
                  {item.title}
                </div>
                {item.price && (
                  <div className="text-sm text-gray-500 md:text-base">{item.price}</div>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    ))}
  </div>
)

export default PriceList
